module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-19.5db3639c.jpg";